import { Icon, Text, useTheme } from "native-base";
import React from "react";
import {
	Image,
	SafeAreaView,
	StyleSheet,
	TouchableOpacity,
	View,
} from "react-native";
import NetInfo from "@react-native-community/netinfo";
import Offline from "../../../assets/offline.png";
import AppScreen from "../../components/AppScreen";
// Config.
import variables from "../../config/vars";
import { isWeb } from "../../utils/utils";
import { FontAwesome } from "@expo/vector-icons";

const OfflineScreen = ({ navigation }) => {
	const { colors } = useTheme();
	const styles = makeStyles(colors);

	const handleRetry = () => {
		NetInfo.fetch().then((state) => {
			// console.log("NET STATUS", state);
			// if (state.isConnected) {
			// 	navigation.reset({
			// 		index: 0,
			// 		routes: [{ name: "Init" }],
			// 	});
			// }
		});
	};

	return (
		<SafeAreaView style={{ flex: 1 }}>
			<View style={styles.imageContainer}>
				<Image
					resizeMode="contain"
					style={styles.image}
					source={{
						uri: isWeb() ? Offline : Image.resolveAssetSource(Offline).uri,
					}}
				/>
				<Text style={styles.offlineTextHeader}>No internet connection</Text>
				<Text style={styles.offlineText}>
					Please check your internet connection and try again
				</Text>
			</View>
			<View style={styles.buttonContainer}>
				<TouchableOpacity style={styles.button} onPress={() => handleRetry}>
					<Text style={styles.buttonText}>TRY AGAIN</Text>
					<Icon
						color={colors.primary["100"]}
						size="sm"
						as={<FontAwesome name="refresh" />}
					/>
				</TouchableOpacity>
			</View>
		</SafeAreaView>
	);
};

const makeStyles = (colors) =>
	StyleSheet.create({
		imageContainer: {
			flex: 4,
			alignItems: "center",
			justifyContent: "center",
			marginTop: 10,
		},
		buttonContainer: {
			flex: 2,
			padding: variables.padding_XSmall,
			justifyContent: "center",
		},
		button: {
			backgroundColor: colors.primary["400"],
			alignItems: "center",
			justifyContent: "center",
			padding: variables.padding_Medium,
			borderRadius: variables.borderRadius,
			flexDirection: "row",
			marginHorizontal: variables.marginHorizontal_Small,
		},
		image: {
			height: variables.baseHeight * 30,
			width: variables.baseWidth * 30,
		},
		buttonText: {
			fontSize: variables.fontSize_Medium,
			fontWeight: "700",
			color: colors.primary["100"],
			marginRight: 10,
		},
		offlineText: {
			fontSize: variables.fontSize_Medium,
			fontWeight: "600",
			color: colors.primary["900"],
			padding: variables.padding_Small,
			textAlign: "center",
			width: variables.baseWidth * 30,
		},
		offlineTextHeader: {
			fontSize: variables.fontSize_Medium,
			fontWeight: "700",
			color: colors.primary["900"],
			alignSelf: "center",
		},
	});

export default OfflineScreen;
